import {
  Text,
  Accordion,
  AccordionItem,
  Box,
  Stack,
  Heading,
} from 'braid-design-system';
import React from 'react';

export interface FAQ {
  question: string;
  answer: string;
}

interface FaqProp {
  faqs: FAQ[];
  headerWeight?: 'weak' | 'regular';
}

export const FaqAccordion = ({ faqs, headerWeight }: FaqProp) => (
  <Box
    data={{ testid: 'faq-accordion' }}
    paddingY="xlarge"
    paddingX="medium"
    background="surface"
  >
    <Stack space="large">
      <Box textAlign="center">
        <Heading level="2" weight={headerWeight}>
          FAQ
        </Heading>
      </Box>

      <Accordion space="large" size="large">
        {faqs.map((faq, index) => (
          <AccordionItem label={faq.question} key={index} id={`faq-${index}`}>
            <Text>{faq.answer}</Text>
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  </Box>
);
